<template>
  <div class="grid-view">
    <div class="main-content fiscal-period">
      <div class="section operations">
        <div class="filters">
          <el-button v-if="$checkPermission(['button_FiscalPeriodList_add'])" type="primary" @click="addHandler">{{ $t('common.btn.new') }}</el-button>
          <el-button v-if="$checkPermission(['button_FiscalPeriodList_edit'])" type="primary" @click="editHandler">{{ $t('common.btn.edit') }}</el-button>
          <el-button type="primary" @click="refreshHandler">{{ $t('common.btn.refresh') }}</el-button>
        </div>
        <div v-if="isEdit" class="filters">
          <el-form label-width="80px">
            <el-form-item :label="$t('CargoMsg.Cargo_TimeFrame')">
              <el-date-picker
                v-model="fiscalPeriod.beginDate"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:160px"
                @change="dateChangeHandler"
              />
              <span style="margin: 0 5px 0 5px">—</span>
              <el-date-picker
                v-model="fiscalPeriod.endDate"
                type="date"
                disabled
                value-format="yyyy-MM-dd"
                style="width:160px"
              />
            </el-form-item>
            <el-form-item>
              <el-checkbox :value="fiscalPeriod.initialPeriod" disabled :label="$t('CargoMsg.Cargo_InitialPeriodOrNot')" />
              <el-checkbox v-model="fiscalPeriod.useGroupExchangeRate" :label="$t('CargoMsg.Cargo_UseGroupExchangeRate')" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
              <el-button type="primary" @click="cancelHandler">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="height: 300px"
        />
      </div>
    </div>
    <financial-exchange-rate-list ref="rateList" :account-set="accountSet" :account-sets="accountSets" :show-period="true" :show-month-selector="false" />
  </div>
</template>

<script>
import FinancialExchangeRateList from '@/views/cargo/v0/FinanceManage/FinanceInterface/FinancialExchangeRateList'
import * as fiscalPeriodApi from '@/api/financeManage/fiscalPeriod'
import ColumnUtils from '@/utils/ColumnUtils'
import DateUtils from '@/utils/dateUtils'
import { getLoading } from '@/utils/utilBaseElement'
import moment from 'moment'

export default {
  name: 'FiscalPeriodList',
  components: { FinancialExchangeRateList },
  props: {
    accountSet: { type: Object, default: null },
    accountSets: { type: Array, default: null }
  },
  data() {
    return {
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true,
          suppressMenu: true,
          suppressMovable: true,
          headerClass: 'text-center'
        },
        pagination: false,
        onRowClicked: this.rowClickHandler
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Annual'),
          field: 'year',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_Months'),
          field: 'month',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_CloseAccountOrNot'),
          field: 'closing',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.booleanColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_InitialPeriodOrNot'),
          field: 'initialPeriod',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.booleanColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_UseGroupExchangeRate'),
          field: 'useGroupExchangeRate',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.booleanColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DateFrom'),
          field: 'beginDate',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.dateColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CompleteDate'),
          field: 'endDate',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.dateColumnLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      fiscalPeriod: {
        beginDate: '',
        endDate: '',
        initialPeriod: false,
        useGroupExchangeRate: false
      },
      isEdit: false,
      selectedItem: null // 表格选中项
    }
  },
  async created() {
    this.refreshHandler()
  },
  methods: {
    addHandler() {
      this.initForm()
      this.isEdit = true
    },
    editHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      // const currentRow = cell ? this.rowData[cell.rowIndex] : null
      const currentRow = cell ? this.selectedItem : null
      if (!currentRow) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.isEdit = true
      this.fiscalPeriod = currentRow
    },
    async refreshHandler() {
      const loading = getLoading()
      this.rowData = await fiscalPeriodApi.query({ accountingSetKey: this.accountSet.uuid })
        .then(resp => resp.data.list)
        .finally(() => loading.close())
      this.gridOptions.api.clearFocusedCell()
      this.selectedItem = null
    },
    saveHandler() {
      if (this.validate()) {
        // const date = DateUtils.dateToStr(this.fiscalPeriod.beginDate)
        // this.fiscalPeriod.year = date.getFullYear()
        // this.fiscalPeriod.month = date.getMonth() + 1
        this.fiscalPeriod.year = moment(this.fiscalPeriod.beginDate).year()
        this.fiscalPeriod.month = moment(this.fiscalPeriod.beginDate).month() + 1
        this.fiscalPeriod.accountSetUuid = this.accountSet.uuid
        if (!this.rowData || this.rowData.length === 0) {
          this.fiscalPeriod.initialPeriod = true
        }
        const loading = getLoading()
        if (this.fiscalPeriod.initialPeriod || this.fiscalPeriod.uuid) {
          fiscalPeriodApi.save(this.fiscalPeriod).then(resp => {
            this.isEdit = false
          }).finally(() => loading.close())
          // fiscalPeriod.save2(saveResultHandler, faultHandler);
        } else {
          fiscalPeriodApi.createNewFiscalPeriod(this.fiscalPeriod).then(resp => {
            this.isEdit = false
          }).finally(() => loading.close())
        }
      }
    },
    dateChangeHandler(value) {
      const date = DateUtils.dateToStr(value)
      if (this.accountSet.periodBeginDay === 0) {
        date.setDate(1)
      } else {
        date.setDate(this.accountSet.periodBeginDay)
      }
      this.fiscalPeriod.beginDate = DateUtils.formatStandardDateTime(date)
      date.setMonth(date.getMonth() + 1)
      date.setDate(0)
      this.fiscalPeriod.endDate = DateUtils.formatStandardDateTime(date)
    },
    cancelHandler() {
      this.isEdit = false
    },
    initForm() {
      const form = {
        beginDate: '',
        endDate: '',
        initialPeriod: false,
        useGroupExchangeRate: false
      }
      Object.assign(this.fiscalPeriod, form)
    },
    validate() {
      if (!this.fiscalPeriod.beginDate) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectStartTime'))
        return false
      } else if (!this.fiscalPeriod.endDate) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectClosureTime'))
        return false
      }
      for (const fp of this.rowData) {
        const fpBegin = DateUtils.dateToStr(fp.beginDate).getTime()
        const fpEnd = DateUtils.dateToStr(fp.endDate).getTime()
        const fiscalPeriodBegin = DateUtils.dateToStr(this.fiscalPeriod.beginDate).getTime()
        const fiscalPeriodEnd = DateUtils.dateToStr(this.fiscalPeriod.endDate).getTime()
        if (fp !== this.fiscalPeriod && (fpBegin <= fiscalPeriodBegin && fpEnd >= fiscalPeriodBegin || fpBegin <= fiscalPeriodEnd && fpEnd >= fiscalPeriodEnd)) {
          this.$message.info(this.$t('CargoMsg.Cargo_TFOTPCTBCWOP'))
          return false
        }
      }
      return true
    },
    rowClickHandler(event) {
      this.selectedItem = event.data
      const cell = this.gridOptions.api.getFocusedCell()
      // const currentRow = cell ? this.rowData[cell.rowIndex] : null
      const currentRow = cell ? this.selectedItem : null
      if (currentRow) {
        this.$refs.rateList.fiscalPeriod = currentRow
      }
    }
  }
}
</script>

<style scoped>
.operations {
  margin: 0 0 10px 10px;
}
</style>
